export default __webpack_public_path__ + "static/media/loader.812fe04d.svg";